<script>
// Components
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";
import UserProfile from "@/router/views/users/user-profile"

// Helpers
import {authComputed} from "@/state/helpers";
import DateUtils from '@/helpers/date';
import UserUtils from '@/helpers/users';
import FinanceUtils from '@/helpers/finance';
import Storage from "@/helpers/storage"

// Services
import FinanceDataService from "@/services/FinanceDataService";
import MarketingDataService from "@/services/MarketingDataService"
import UsersDataService from "@/services/UsersDataService"

// External Components
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import isEmpty from "is-empty";

// Lib

const ads = {};
const marketing = {};
const organic = {};
const adsData1 = {};
const adsData2 = {};

export default {
  name: "stats",
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Finance Analytics",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    VueTabs,
    VTab,
    UserProfile,
    CoolLightBox,
  },
  methods: {
    ...UserUtils,
    ...DateUtils,
    ...FinanceUtils,

    handlePageChange(value) {
      this.page = value;
      this.loadProjections();
    },

    handleDisplayChange() {
      this.loadProjections();
    },

    handleDateProjectionsChange() {
      let now = new this.$moment();
      switch(this.filtersProjection.dates.selected) {
        case "today":
          this.filtersProjection.fromDate = now.format('YYYY-MM-DD');
          this.filtersProjection.toDate = now.format('YYYY-MM-DD');
          break;
        case "tomorrow":
          this.filtersProjection.fromDate = now.add(1, 'day').format('YYYY-MM-DD');
          this.filtersProjection.toDate = this.filtersProjection.fromDate;
          break;
        case "week":
          this.filtersProjection.fromDate = now.format('YYYY-MM-DD');
          this.filtersProjection.toDate = now.add(5, 'day').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersProjection.fromDate = null;
          this.filtersProjection.toDate = null;
          break;
      }
    },

    handleDatePerformanceChange() {
      let now = new this.$moment();
      switch(this.filtersPerformance.dates.selected) {
        case "today":
          this.filtersPerformance.fromDate = now.format('YYYY-MM-DD');
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersPerformance.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersPerformance.toDate = this.filtersPerformance.fromDate;
          break;
        case "week":
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformance.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformance.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformance.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersPerformance.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersPerformance.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformance.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersPerformance.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformance.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersPerformance.fromDate = null;
          this.filtersPerformance.toDate = null;
          break;
      }
    },

    handleDatePerformancePacksChange() {
      let now = new this.$moment();
      switch(this.filtersPerformancePacks.dates.selected) {
        case "today":
          this.filtersPerformancePacks.fromDate = now.format('YYYY-MM-DD');
          this.filtersPerformancePacks.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersPerformancePacks.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersPerformancePacks.toDate = this.filtersPerformancePacks.fromDate;
          break;
        case "week":
          this.filtersPerformancePacks.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformancePacks.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersPerformancePacks.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformancePacks.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersPerformancePacks.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformancePacks.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersPerformancePacks.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersPerformancePacks.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersPerformancePacks.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformancePacks.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersPerformancePacks.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformancePacks.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersPerformancePacks.fromDate = null;
          this.filtersPerformancePacks.toDate = null;
          break;
      }
    },

    handleDateOffersChange() {
      let now = new this.$moment();
      switch(this.filtersOffers.dates.selected) {
        case "today":
          this.filtersOffers.fromDate = now.format('YYYY-MM-DD');
          this.filtersOffers.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersOffers.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersOffers.toDate = this.filtersOffers.fromDate;
          break;
        case "week":
          this.filtersOffers.toDate = now.format('YYYY-MM-DD');
          this.filtersOffers.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersOffers.toDate = now.format('YYYY-MM-DD');
          this.filtersOffers.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersOffers.toDate = now.format('YYYY-MM-DD');
          this.filtersOffers.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersOffers.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersOffers.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersOffers.toDate = now.format('YYYY-MM-DD');
          this.filtersOffers.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersOffers.toDate = now.format('YYYY-MM-DD');
          this.filtersOffers.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersOffers.fromDate = null;
          this.filtersOffers.toDate = null;
          break;
      }
    },

    handleDatePerformanceLeadsChange() {
      let now = new this.$moment();
      switch(this.filtersPerformanceLeads.dates.selected) {
        case "today":
          this.filtersPerformanceLeads.fromDate = now.format('YYYY-MM-DD');
          this.filtersPerformanceLeads.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersPerformanceLeads.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersPerformanceLeads.toDate = this.filtersPerformance.fromDate;
          break;
        case "week":
          this.filtersPerformanceLeads.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformanceLeads.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersPerformanceLeads.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformanceLeads.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersPerformanceLeads.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformanceLeads.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersPerformanceLeads.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersPerformanceLeads.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersPerformanceLeads.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformanceLeads.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersPerformanceLeads.toDate = now.format('YYYY-MM-DD');
          this.filtersPerformanceLeads.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersPerformanceLeads.fromDate = null;
          this.filtersPerformanceLeads.toDate = null;
          break;
      }
    },

    getRequestParamsProjections() {
      const params = {};

      params["page"] = this.page - 1;
      params["size"] = this.pageSizes.selected;

      if (this.filtersProjection.dates.selected === 'custom' && this.filtersProjection.dates.dateRange !== null) {
        this.filtersProjection.fromDate = this.$moment(this.filtersProjection.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersProjection.toDate = this.$moment(this.filtersProjection.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersProjection.fromDate === null)
        this.handleDateProjectionsChange();

      if (this.filtersProjection.toDate !== null)
        params['toDate'] = this.filtersProjection.toDate;

      if (this.filtersProjection.fromDate !== null)
        params['fromDate'] = this.filtersProjection.fromDate;

      params['subscription'] = this.filtersProjection.subscriptions.selected;
      params['paymentMethod'] = this.filtersProjection.paymentMethod.selected;
      params['paymentProcessor'] = this.filtersProjection.paymentProcessor.selected;
      params['status'] = this.filtersProjection.status.selected;
      params['countries'] = this.filtersProjection.countries.selected;
      params['organic'] = this.filtersProjection.organic.selected;

      if (this.filtersProjection.adsData3.selected !== 'all') {
        params['ads'] = this.filtersProjection.adsData3.selected;
      }
      else if (this.filtersProjection.adsData2.selected !== 'all') {
        params['ads'] = this.filtersProjection.adsData2.selected;
      }
      else if (this.filtersProjection.adsData1.selected !== 'all') {
        params['ads'] = this.filtersProjection.adsData1.selected;
      }
      else {
        params['ads'] = this.filtersProjection.ads.selected;
      }

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getRequestParamsOffers() {
      const params = {};

      if (this.filtersOffers.dates.selected === 'custom' && this.filtersOffers.dates.dateRange !== null) {
        this.filtersOffers.fromDate = this.$moment(this.filtersOffers.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersOffers.toDate = this.$moment(this.filtersOffers.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersOffers.fromDate === null)
        this.handleDateOffersChange();

      if (this.filtersOffers.toDate !== null)
        params['toDate'] = this.filtersOffers.toDate;

      if (this.filtersOffers.fromDate !== null)
        params['fromDate'] = this.filtersOffers.fromDate;

      params['countries'] = this.filtersOffers.countries.selected;
      params['paymentMethod'] = this.filtersOffers.paymentMethod.selected;
      params['paymentProcessor'] = this.filtersOffers.paymentProcessor.selected;

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getRequestParamsPerformancePacks() {
      const params = {};

      if (this.filtersPerformancePacks.dates.selected === 'custom' && this.filtersPerformancePacks.dates.dateRange !== null) {
        this.filtersPerformancePacks.fromDate = this.$moment(this.filtersPerformancePacks.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersPerformancePacks.toDate = this.$moment(this.filtersPerformancePacks.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersPerformancePacks.fromDate === null)
        this.handleDatePerformancePacksChange();

      if (this.filtersPerformancePacks.toDate !== null)
        params['toDate'] = this.filtersPerformancePacks.toDate;

      if (this.filtersPerformancePacks.fromDate !== null)
        params['fromDate'] = this.filtersPerformancePacks.fromDate;

      params['pack'] = this.filtersPerformancePacks.packs.selected;
      params['paymentMethod'] = this.filtersPerformancePacks.paymentMethod.selected;
      params['paymentProcessor'] = this.filtersPerformancePacks.paymentProcessor.selected;
      params['countries'] = this.filtersPerformancePacks.countries.selected;
      params['offer'] = this.filtersPerformancePacks.promo.selected;
      params['organic'] = this.filtersPerformancePacks.organic.selected;
      if (this.filtersPerformancePacks.adsData3.selected !== 'all') {
        params['ads'] = this.filtersPerformancePacks.adsData3.selected;
      }
      else if (this.filtersPerformancePacks.adsData2.selected !== 'all') {
        params['ads'] = this.filtersPerformancePacks.adsData2.selected;
      }
      else if (this.filtersPerformancePacks.adsData1.selected !== 'all') {
        params['ads'] = this.filtersPerformancePacks.adsData1.selected;
      }
      else {
        params['ads'] = this.filtersPerformancePacks.ads.selected;
      }

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getRequestParamsPerformance() {
      const params = {};

      if (this.filtersPerformance.dates.selected === 'custom' && this.filtersPerformance.dates.dateRange !== null) {
        this.filtersPerformance.fromDate = this.$moment(this.filtersPerformance.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersPerformance.toDate = this.$moment(this.filtersPerformance.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersPerformance.fromDate === null)
        this.handleDatePerformanceChange();

      if (this.filtersPerformance.toDate !== null)
        params['toDate'] = this.filtersPerformance.toDate;

      if (this.filtersPerformance.fromDate !== null)
        params['fromDate'] = this.filtersPerformance.fromDate;

      params['subscription'] = this.filtersPerformance.subscriptions.selected;
      params['paymentMethod'] = this.filtersPerformance.paymentMethod.selected;
      params['paymentProcessor'] = this.filtersPerformance.paymentProcessor.selected;
      params['countries'] = this.filtersPerformance.countries.selected;
      params['offer'] = this.filtersPerformance.promo.selected;
      params['organic'] = this.filtersPerformance.organic.selected;
      if (this.filtersPerformance.adsData3.selected !== 'all') {
        params['ads'] = this.filtersPerformance.adsData3.selected;
      }
      else if (this.filtersPerformance.adsData2.selected !== 'all') {
        params['ads'] = this.filtersPerformance.adsData2.selected;
      }
      else if (this.filtersPerformance.adsData1.selected !== 'all') {
        params['ads'] = this.filtersPerformance.adsData1.selected;
      }
      else {
        params['ads'] = this.filtersPerformance.ads.selected;
      }


      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getRequestParamsPerformanceLeads() {
      const params = {};

      if (this.filtersPerformanceLeads.dates.selected === 'custom' && this.filtersPerformanceLeads.dates.dateRange !== null) {
        this.filtersPerformanceLeads.fromDate = this.$moment(this.filtersPerformanceLeads.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersPerformanceLeads.toDate = this.$moment(this.filtersPerformanceLeads.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersPerformanceLeads.fromDate === null)
        this.handleDatePerformanceLeadsChange();

      if (this.filtersPerformanceLeads.toDate !== null)
        params['toDate'] = this.filtersPerformanceLeads.toDate;

      if (this.filtersPerformanceLeads.fromDate !== null)
        params['fromDate'] = this.filtersPerformanceLeads.fromDate;

      if (this.filtersPerformanceLeads.limitDate !== null)
        params['limitDate'] = this.filtersPerformanceLeads.limitDate;

      params['gender'] = this.filtersPerformanceLeads.genders.selected;
      params['subscription'] = this.filtersPerformanceLeads.subscriptions.selected;
      params['pack'] = this.filtersPerformanceLeads.packs.selected;
      params['countries'] = this.filtersPerformanceLeads.countries.selected;
      params['organic'] = this.filtersPerformanceLeads.organic.selected;

      if (!isEmpty(this.filtersPerformanceLeads.minAge)) {
        params['minAge'] = parseInt(this.filtersPerformanceLeads.minAge);
      }

      if (!isEmpty(this.filtersPerformanceLeads.maxAge)) {
        params['maxAge'] = parseInt(this.filtersPerformanceLeads.maxAge);
      }

      if (this.filtersPerformanceLeads.adsData3.selected !== 'all') {
        params['ads'] = this.filtersPerformanceLeads.adsData3.selected;
      }
      else if (this.filtersPerformanceLeads.adsData2.selected !== 'all') {
        params['ads'] = this.filtersPerformanceLeads.adsData2.selected;
      }
      else if (this.filtersPerformanceLeads.adsData1.selected !== 'all') {
        params['ads'] = this.filtersPerformanceLeads.adsData1.selected;
      }
      else {
        params['ads'] = this.filtersPerformanceLeads.ads.selected;
      }

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    loadProjectionsStats() {
      const params = this.getRequestParamsProjections();
      FinanceDataService
          .getProjectionsStats(params)
          .then(response => {
            const {stats, products, processors} = response.data;
            this.stats.active = stats.active;
            this.stats.suspended = stats.suspended;
            this.stats.currencies = stats.currencies;

            this.productsGraph.series = products.series;
            this.productsGraph.chartOptions = {...this.productsGraph.chartOptions, ...{
                labels: products.labels
              }};

            this.processorsGraph.series = processors.series;
            this.processorsGraph.chartOptions = {...this.processorsGraph.chartOptions, ...{
                labels: processors.labels
              }};
          })
          .catch(error => {
            window.console.error(error);
          });
    },

    loadProjections() {
      this.isLoadingProjection = true;
      const params = this.getRequestParamsProjections();
      FinanceDataService
          .getProjections(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.projections = items;
            this.count = totalItems;
            this.isLoadingProjection = false;
            this.getMediaThumb();
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("finance.errorTransactionsNoResult"));
            this.isLoading = false;
          });
    },

    loadPerformance() {
      this.isLoadingPerformance = true;
      const params = this.getRequestParamsPerformance();
      FinanceDataService
          .getPerformance(params)
          .then(response => {
            const {stats, historyGraph, processorGraph} = response.data;
            this.stats.renews_success = stats.success;
            this.stats.renews_failed = stats.failed;
            this.stats.renews_perf = stats.performance;

            this.performanceProcessorGraph.chartOptions = {...this.performanceProcessorGraph.chartOptions, ...{
                xaxis: {
                  categories: processorGraph.categories
                }
              }};
            this.performanceProcessorGraph.series = processorGraph.series;

            this.$refs.performanceHistoryChart.updateSeries([{
              name: "Success",
              type: 'bar',
              data: historyGraph.success
            },{
              name: "Failed",
              type: 'bar',
              data: historyGraph.failed
            }]);

            this.$refs.performanceHistoryRatioChart.updateSeries([{
              name: "Performance",
              data: historyGraph.performance
            }]);
          })
          .catch(error => {
            window.console.error(error);
          })
          .finally(() => {
            this.isLoadingPerformance = false;
          });
    },

    loadPerformancePacks() {
      this.isLoadingPerformancePacks = true;
      const params = this.getRequestParamsPerformancePacks();
      FinanceDataService
          .getPerformancePacks(params)
          .then(response => {
            const {stats, historyGraph, processorGraph} = response.data;
            this.stats.renews_packs_success = stats.success;
            this.stats.renews_packs_failed = stats.failed;
            this.stats.renews_packs_perf = stats.performance;

            this.performancePacksProcessorGraph.chartOptions = {...this.performancePacksProcessorGraph.chartOptions, ...{
                xaxis: {
                  categories: processorGraph.categories
                }
              }};
            this.performancePacksProcessorGraph.series = processorGraph.series;

            this.$refs.performancePacksHistoryChart.updateSeries([{
              name: "Success",
              type: 'bar',
              data: historyGraph.success
            },{
              name: "Failed",
              type: 'bar',
              data: historyGraph.failed
            }]);

            this.$refs.performancePacksHistoryRatioChart.updateSeries([{
              name: "Performance",
              data: historyGraph.performance
            }]);
          })
          .catch(error => {
            window.console.error(error);
          })
          .finally(() => {
            this.isLoadingPerformancePacks = false;
          });
    },

    loadOffers() {
      const params = this.getRequestParamsOffers();
      this.isLoadingOffers = true;
      FinanceDataService
          .getOffersStats(params)
          .then(response => {
            const { stats } = response.data;
            this.statsOffers = stats;
          })
          .catch(error => {
            window.console.error(error);
          })
          .finally(() => {
            this.isLoadingOffers = false;
          });
    },

    loadPerformanceLeads() {
      this.isLoadingPerformanceLeads = true;
      const params = this.getRequestParamsPerformanceLeads();
      FinanceDataService
          .getPerformanceLeads(params)
          .then(response => {
            this.isLoadingPerformanceLeads = false;
            const {stats, historyGraph, historyAmountGraph, ageGraph, historyReasonsGraph, historyAmountCumulativeGraph} = response.data;
            this.stats.leads = stats.leads;
            this.stats.paid = stats.paid;
            this.stats.remainingSubs = stats.remainingSubs;
            this.stats.orders = stats.orders;
            this.stats.leads_perf = stats.performance;
            this.stats.lead_currencies = stats.currencies;
            this.stats.total_amount_avg = stats.totalAmountAvg;
            this.stats.totalAmountEarned = stats.totalAmountEarned;
            this.stats.ageData = ageGraph.ageData;

            this.ageLeadsGraph.series = ageGraph.seriesLeadsAge;
            this.ageLeadsGraph.chartOptions = {...this.ageLeadsGraph.chartOptions, ...{
                labels: ageGraph.labelsLeadsAge
              }};

            this.agePaidGraph.series = ageGraph.seriesPaidAge;
            this.agePaidGraph.chartOptions = {...this.agePaidGraph.chartOptions, ...{
                labels: ageGraph.labelsPaidAge
              }};

            this.$refs.performanceReasonAllHistoryChart.updateSeries([
              {
                name: "Unlock Like",
                type: 'bar',
                data: historyReasonsGraph.all.likes
              },
              {
                name: "Account",
                type: 'bar',
                data: historyReasonsGraph.all.settings
              },
              {
                name: "IB Accept",
                type: 'bar',
                data: historyReasonsGraph.all.acceptIceBreakers
              },
              {
                name: "IB Send",
                type: 'bar',
                data: historyReasonsGraph.all.sendIceBreakers
              },
              {
                name: "Send Likes",
                type: 'bar',
                data: historyReasonsGraph.all.sendLikes
              },
              {
                name: "Unlock VideoLike",
                type: 'bar',
                data: historyReasonsGraph.all.videoLikes
              }
            ]);
            this.$refs.performanceReasonLikeChart.updateSeries([
              {
                name: "Unlock Like",
                type: 'area',
                data: historyReasonsGraph.likes
              }
            ]);
            this.$refs.performanceReasonAccountChart.updateSeries([
              {
                name: "Account",
                type: 'area',
                data: historyReasonsGraph.settings
              }
            ]);
            this.$refs.performanceReasonIBAcceptChart.updateSeries([
              {
                name: "IB Accept",
                type: 'area',
                data: historyReasonsGraph.acceptIceBreakers
              }
            ]);
            this.$refs.performanceReasonIBSendChart.updateSeries([
              {
                name: "IB Send",
                type: 'area',
                data: historyReasonsGraph.sendIceBreakers
              }
            ]);
            this.$refs.performanceReasonVideoLikeChart.updateSeries([
              {
                name: "Unlock VideoLike",
                type: 'area',
                data: historyReasonsGraph.videoLikes
              }
            ]);
            this.$refs.performanceReasonSendLikeChart.updateSeries([
              {
                name: "Send Likes",
                type: 'area',
                data: historyReasonsGraph.sendLikes
              }
            ]);

            this.$refs.performanceLeadsCumulativeHistoryAmountChart.updateSeries([
              {
                name: "Amount HT",
                type: 'area',
                data: historyAmountCumulativeGraph.amount
              }]);

            this.$refs.performanceLeadsCumulativeHistoryPaymentsChart.updateSeries([
              {
                name: "Firsts",
                type: 'column',
                data: historyAmountCumulativeGraph.firsts
              }, {
                name: "Renews",
                type: 'column',
                data: historyAmountCumulativeGraph.renews
              }]);

            this.$refs.performanceLeadsAmountHistoryChart.updateSeries([
                {
              name: "1st Payments",
              type: 'column',
              data: historyAmountGraph.orders
            },{
              name: "Amount HT",
              type: 'line',
              data: historyAmountGraph.amount
            }]);

            this.$refs.performanceLeadsHistoryChart.updateSeries([
              {
                name: "Leads",
                type: 'column',
                data: historyGraph.leads
              },{
                name: "Paid Ratio",
                type: 'line',
                data: historyGraph.performance
              }]);

            this.$refs.performanceAgeChart.updateSeries([
            {
              name: "Leads",
              type: 'column',
              data: ageGraph.paidGraph.leads
            },{
              name: "Paid Members",
              type: 'column',
              data: ageGraph.paidGraph.paid
            },{
              name: "Performance",
              type: 'line',
              data: ageGraph.paidGraph.performance
            }]);
          })
          .catch(error => {
            window.console.error(error);
            this.isLoadingPerformanceLeads = false;
          });
    },

    processProjectionsFilters() {
      this.loadProjections();
      this.loadProjectionsStats();
    },

    processPerformanceFilters() {
      this.loadPerformance();
    },

    processPerformancePacksFilters() {
      this.loadPerformancePacks();
    },

    processOffersFilters() {
      this.loadOffers();
    },

    processPerformanceLeadsFilters() {
      this.loadPerformanceLeads();
    },

    getFilters() {
      MarketingDataService.getAdsNonOrganicFilters()
          .then(response => {
            marketing.ads = response.data.filters.ads;
            response.data.filters.ads.forEach(ad => {
              this.filtersPerformanceLeads.ads.options.push(ad);
              this.filtersPerformance.ads.options.push(ad);
              this.filtersProjection.ads.options.push(ad);
            });
          })
          .catch(error => {
            window.console.log(error);
            this.$toast.error(this.$t("marketing.getAdsNonOrganicFilters"));
          });
    },

    getMediaThumb() {
      if (this.projections.length > 0)
        this.projections.forEach(proj => {
          if (proj.photo && proj.photo.length > 0)
            Storage.getUserMedia(proj.userId, proj.photo, 'projection-user-'+proj.id);

        });
    },

    getAdsFiltersData1(filters, value) {
      filters.adsData1.selected = 'all';
      filters.adsData2.selected = 'all';
      filters.adsData3.selected = 'all';
      filters.adsData1.options = [{
        value: 'all', text: 'All Data1'
      }];
      filters.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(ads[value])) {
        MarketingDataService.getAdsNonOrganicData1Filters(value)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                filters.adsData1.options.push(ad);
              });

              ads[value] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData1Filters"));
            });
      }
      else {
        ads[value].forEach(ad => {
          filters.adsData1.options.push(ad);
        });
      }
    },

    getAdsFiltersData2(filters, value) {
      filters.adsData2.selected = 'all';
      filters.adsData3.selected = 'all';
      filters.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData1[value])) {
        MarketingDataService.getAdsNonOrganicData2Filters(value)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                filters.adsData2.options.push(ad);
              });

              adsData1[value] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData2Filters"));
            });
      }
      else {
        adsData1[value].forEach(ad => {
          filters.adsData2.options.push(ad);
        });
      }
    },

    getAdsFiltersData3(filters, value) {
      filters.adsData3.selected = 'all';
      filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData2[value])) {
        MarketingDataService.getAdsNonOrganicData3Filters(value)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                filters.adsData3.options.push(ad);
              });

              adsData2[value] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData3Filters"));
            });
      }
      else {
        adsData2[value].forEach(ad => {
          filters.adsData3.options.push(ad);
        });
      }
    },

    /* User profile */
    openUserPane() {
      if (!this.isUserPaneDisplayed)
        this.isUserPaneDisplayed = true;
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(userId) {
      const isUserAlreadyDisplayed = this.userTabs.findIndex(x => x.userId === userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = userId; }, 100);
      }
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    },
  },
  mounted() {
    this.getFilters();
    this.processPerformanceLeadsFilters();
    this.processProjectionsFilters();
    this.processPerformanceFilters();
    this.processPerformancePacksFilters();
    this.processOffersFilters();
  },
  computed: {
    ...authComputed
  },
  watch: {
    "filtersPerformance.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filtersPerformance.ads.selected = 'all';
        this.filtersPerformance.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filtersPerformance.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        }
        else {
          organic.ads.forEach(ad => {
            this.filtersPerformance.ads.options.push(ad);
          });
        }
      }
      else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filtersPerformance.ads.selected = 'all';
        this.filtersPerformance.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filtersPerformance.ads.options.push(ad);
          });
        }
      }
    },
    "filtersPerformancePacks.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filtersPerformancePacks.ads.selected = 'all';
        this.filtersPerformancePacks.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filtersPerformancePacks.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        }
        else {
          organic.ads.forEach(ad => {
            this.filtersPerformancePacks.ads.options.push(ad);
          });
        }
      }
      else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filtersPerformancePacks.ads.selected = 'all';
        this.filtersPerformancePacks.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filtersPerformancePacks.ads.options.push(ad);
          });
        }
      }
    },
    "filtersPerformanceLeads.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filtersPerformanceLeads.ads.selected = 'all';
        this.filtersPerformanceLeads.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filtersPerformanceLeads.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        }
        else {
          organic.ads.forEach(ad => {
            this.filtersPerformanceLeads.ads.options.push(ad);
          });
        }
      }
      else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filtersPerformanceLeads.ads.selected = 'all';
        this.filtersPerformanceLeads.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filtersPerformanceLeads.ads.options.push(ad);
          });
        }
      }
    },
    "filtersProjection.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filtersProjection.ads.selected = 'all';
        this.filtersProjection.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filtersProjection.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        }
        else {
          organic.ads.forEach(ad => {
            this.filtersProjection.ads.options.push(ad);
          });
        }
      }
      else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filtersProjection.ads.selected = 'all';
        this.filtersProjection.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filtersProjection.ads.options.push(ad);
          });
        }
      }
    },

    "filtersPerformance.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData1(this.filtersPerformance, newVal);
    },
    "filtersPerformancePacks.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData1(this.filtersPerformancePacks, newVal);
    },
    "filtersPerformanceLeads.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData1(this.filtersPerformanceLeads, newVal);
    },
    "filtersProjection.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData1(this.filtersProjection, newVal);
    },

    "filtersPerformance.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData2(this.filtersPerformance, newVal);
    },
    "filtersPerformancePacks.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData2(this.filtersPerformancePacks, newVal);
    },
    "filtersPerformanceLeads.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData2(this.filtersPerformanceLeads, newVal);
    },
    "filtersProjection.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData2(this.filtersProjection, newVal);
    },

    "filtersPerformance.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData3(this.filtersPerformance, newVal);
    },
    "filtersPerformancePacks.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData3(this.filtersPerformancePacks, newVal);
    },
    "filtersPerformanceLeads.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData3(this.filtersPerformanceLeads, newVal);
    },
    "filtersProjection.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.getAdsFiltersData3(this.filtersProjection, newVal);
    }
  },

  data() {
    return {
      isLoadingProjection: false,
      isLoadingPerformance: false,
      isLoadingPerformancePacks: false,
      isLoadingPerformanceLeads: false,
      isLoadingOffers: false,
      title: this.$t("menuitems.finance.stats"),
      projections: [],
      page: 1,
      count: 0,
      pageSizes: {
        options: ['20', '50', '100'],
        selected: '50'
      },
      stats: {
        active: '-',
        suspended: '-',
        currencies: '-',
        renews_success: '-',
        renews_packs_success: '-',
        renews_failed: '-',
        renews_packs_failed: '-',
        renews_perf: '-',
        renews_packs_perf: '-',
        paid: '-',
        orders: '-',
        remainingSubs: '-',
        leads: '-',
        leads_perf: '-',
        total_amount_avg: '-',
        totalAmountEarned: '-',
        lead_currencies: [],
        ageData: []
      },
      statsOffers: [],

      productsGraph: {
        series:[],
        chartOptions: {
          chart: {
            id: 'renews-products',
            type: 'donut',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'projections-products'
                },
                svg: {
                  filename: 'projections-products'
                }
              }
            }
          },
          dataLabels: {
            enabled: true
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          legend: {
            position: 'left'
          },
        }
      },
      processorsGraph: {
        series:[],
        chartOptions: {
          chart: {
            id: 'renews-processors',
            type: 'donut',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'projections-processors'
                },
                svg: {
                  filename: 'projections-processors'
                }
              }
            }
          },
          dataLabels: {
            enabled: true
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          legend: {
            position: 'left'
          },
        }
      },
      performanceProcessorGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 200,
            stacked: true,
            stackType: '100%',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-processors-renews'
                },
                svg: {
                  filename: 'performance-processors-renews'
                }
              }
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
            dataLabels: {
              enabled: true,
              style: {
                colors: ["#ffffff"],
              }
            }
          },
          dataLabels: {
            style: {
              fontSize: '12px',
              fontWeight: 'bold',
            },
            background: {
              enabled: true,
              foreColor: '#fff',
              borderRadius: 2,
              padding: 4,
              opacity: 0.9,
              borderWidth: 1,
              borderColor: '#fff'
            },
          },
          colors: ["#556ee6", "#f46a6a"],
          stroke: {
            width: 1,
            colors: ['#fcf4e5']
          },
          xaxis: {
            categories: [],
          },
          fill: {
            opacity: 1

          },
          legend: {
            show: false
          }
        },
      },
      performancePacksProcessorGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 200,
            stacked: true,
            stackType: '100%',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-packs-processors-renews'
                },
                svg: {
                  filename: 'performance-packs-processors-renews'
                }
              }
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
            dataLabels: {
              enabled: true,
              style: {
                colors: ["#ffffff"],
              }
            }
          },
          dataLabels: {
            style: {
              fontSize: '12px',
              fontWeight: 'bold',
            },
            background: {
              enabled: true,
              foreColor: '#fff',
              borderRadius: 2,
              padding: 4,
              opacity: 0.9,
              borderWidth: 1,
              borderColor: '#fff'
            },
          },
          colors: ["#556ee6", "#f46a6a"],
          stroke: {
            width: 1,
            colors: ['#fcf4e5']
          },
          xaxis: {
            categories: [],
          },
          fill: {
            opacity: 1

          },
          legend: {
            show: false
          }
        },
      },
      performanceGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-renews'
                },
                svg: {
                  filename: 'performance-renews'
                }
              }
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: '13px',
                  }
                }
              }
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              axisTicks: {
                show: true
              },
              title: {
                text: "Nb"
              },
            },
          ],
          colors: ["#556ee6", "#f46a6a"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      performancePacksGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-packs-renews'
                },
                svg: {
                  filename: 'performance-packs-renews'
                }
              }
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: '13px',
                  }
                }
              }
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              axisTicks: {
                show: true
              },
              title: {
                text: "Nb"
              },
            },
          ],
          colors: ["#556ee6", "#f46a6a"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      performanceRatioGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'area',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-renews-ratio'
                },
                svg: {
                  filename: 'performance-renews-ratio'
                }
              }
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          stroke: {
            curve: 'smooth',
            width: 1,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              show: false,
              axisTicks: {
                show: false
              },
              title: {
                text: "Ratio"
              },
            },
          ],
          colors: ["#34c38f"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },
      performancePacksRatioGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'area',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-packs-renews-ratio'
                },
                svg: {
                  filename: 'performance-packs-renews-ratio'
                }
              }
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          stroke: {
            curve: 'smooth',
            width: 1,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              show: false,
              axisTicks: {
                show: false
              },
              title: {
                text: "Ratio"
              },
            },
          ],
          colors: ["#34c38f"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },

      performanceLeadsGraph: {
        series: [],
        chartOptions: {
          chart: {
            height: 350,
            id: "performance-leads",
            group: "performance-leads",
            type: 'line',
            stacked: false,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-leads'
                },
                svg: {
                  filename: 'performance-leads'
                }
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: [1, 4]
          },
          colors: ["#556ee6", "#666666"],
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#556ee6'
              },
              labels: {
                style: {
                  colors: '#556ee6',
                }
              },
              title: {
                text: "Leads",
                style: {
                  color: '#556ee6',
                }
              },
              tooltip: {
                enabled: true
              }
            },
            {
              seriesName: 'Ratio',
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#666666'
              },
              labels: {
                style: {
                  colors: '#666666',
                }
              },
              title: {
                text: "Paid Ratio",
                style: {
                  color: '#666666',
                }
              },
            },
          ],
          tooltip: {
            shared: true,
            intersect: false
          },
          legend: {
            position: 'bottom',
          }
        },
      },

      performanceLeadsCumulativeAmountGraph: {
        series: [],
        chartOptions: {
          chart: {
            height: 300,
            id: "cumulative-amount",
            type: 'area',
            group: 'cumulative',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-leads-cumulative-amount'
                },
                svg: {
                  filename: 'performance-leads-cumulative-amount'
                }
              }
            }
          },
          title: {
            text: "Cumulative Amount HT earned",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight',
            width: 4
          },
          colors: ["#c35534"],
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#666666'
              },
              labels: {
                style: {
                  colors: '#666666',
                }
              },
              title: {
                text: "Amount HT",
                style: {
                  color: '#666666',
                }
              },
              tooltip: {
                enabled: true
              }
            },
          ],
          tooltip: {
            shared: true,
            intersect: false
          },
          legend: {
            position: 'bottom',
          }
        },
      },
      performanceLeadsCumulativePaymentsGraph: {
        series: [],
        chartOptions: {
          chart: {
            id: "payments-history",
            height: 300,
            type: 'bar',
            group: 'cumulative',
            stacked: true,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-leads-cumulative-payments'
                },
                svg: {
                  filename: 'performance-leads-cumulative-payments'
                }
              }
            }
          },
          title: {
            text: "Payments history",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          dataLabels: {
            enabled: false
          },
          colors: ["#34c38f", "#2983FF"],
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#666666'
              },
              labels: {
                style: {
                  colors: '#666666',
                }
              },
              title: {
                text: "Payments",
                style: {
                  color: '#666666',
                }
              },
              tooltip: {
                enabled: true
              }
            }
          ],
          tooltip: {
            shared: true,
            intersect: false
          },
          legend: {
            position: 'bottom',
          }
        },
      },

      performanceLeadsAmountGraph: {
        series: [],
        chartOptions: {
          chart: {
            height: 350,
            id: "performance-amount",
            group: "performance-leads",
            type: 'line',
            stacked: false,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-leads'
                },
                svg: {
                  filename: 'performance-leads'
                }
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: [1, 4]
          },
          colors: ["#34c38f", "#666666"],
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#00E396'
              },
              labels: {
                style: {
                  colors: '#00E396',
                }
              },
              title: {
                text: "1st Payments",
                style: {
                  color: '#00E396',
                }
              },
              tooltip: {
                enabled: true
              }
            },
            {
              seriesName: 'amount',
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#666666'
              },
              labels: {
                style: {
                  colors: '#666666',
                }
              },
              title: {
                text: "Amount HT",
                style: {
                  color: '#666666',
                }
              },
            },
          ],
          tooltip: {
            shared: true,
            intersect: false
          },
          legend: {
            position: 'bottom',
          }
        },
      },
      performanceAgeGraph: {
        series: [],
        chartOptions: {
          title: {
            text: "Payments Age Performance",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          chart: {
            height: 350,
            type: 'line',
            stacked: false,
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-leads-age'
                },
                svg: {
                  filename: 'performance-leads-age'
                }
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          colors: ["#666666", "#F1B44C", "#00E396"],
          xaxis: {
            categories: ["18-24", "25-29", "30-34", "35-39", "40-44", "45-49", "50-54", "55-59", "60-64", "65-69", "70-100"],
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              seriesName: "Leads",
              decimalsInFloat: 0,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#666666'
              },
              labels: {
                style: {
                  colors: '#666666',
                }
              },
              title: {
                text: "Leads",
                style: {
                  color: '#666666',
                }
              },
              tooltip: {
                enabled: true
              }
            },
            {
              seriesName: "Paid Members",
              decimalsInFloat: 0,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#F1B44C'
              },
              labels: {
                style: {
                  colors: '#F1B44C',
                }
              },
              title: {
                text: "Paid Members",
                style: {
                  color: '#F1B44C',
                }
              },
              tooltip: {
                enabled: true
              }
            },
            {
              seriesName: 'Performance',
              decimalsInFloat: 2,
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#00E396'
              },
              labels: {
                style: {
                  colors: '#00E396',
                }
              },
              title: {
                text: "Paid Ratio",
                style: {
                  color: '#00E396',
                }
              },
            },
          ],
          tooltip: {
            shared: true,
            intersect: false
          },
          legend: {
            position: 'bottom',
          }
        },
      },

      reasonAllGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'bar',
            stacked: true,
            stackType: '100%',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'reasons-all'
                },
                svg: {
                  filename: 'reasons-all'
                }
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          colors: ["#2983FF", "#A300D6", "#F9CE1D", "#5653FE", "#4ECDC4", "#4CAF50", "#D4526E", "#90EE7E", "#FF9800"],
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#00E396'
              },
              labels: {
                style: {
                  colors: '#00E396',
                }
              },
              title: {
                text: "Orders",
                style: {
                  color: '#00E396',
                }
              },
              tooltip: {
                enabled: true
              }
            }],
          tooltip: {
            shared: true,
            intersect: false
          },
          legend: {
            position: 'bottom',
          }
        }
      },
      reasonUnlockLikeGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'area',
            sparkline: {
              enabled: false
            }
          },
          title: {
            text: "Reason Unlock Likes",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight',
            width: 2,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              show: true,
              axisTicks: {
                show: false,
              },
              axisBorder: {
                show: true,
              },
              labels: {
                show: false,
                style: {
                  colors: '#556ee6',
                }
              },
            }
          ],
          tooltip: {
            fixed: {
              enabled: false
            },
            x: {
              show: true
            },
            y: {
              show: true
            },
            marker: {
              show: false
            }
          }
        }
      },
      reasonUnlockVideoLikeGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'area',
            sparkline: {
              enabled: false
            }
          },
          title: {
            text: "Reason Unlock VideoLikes",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight',
            width: 2,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              show: true,
              axisTicks: {
                show: false,
              },
              axisBorder: {
                show: true,
              },
              labels: {
                show: false,
                style: {
                  colors: '#556ee6',
                }
              },
            }
          ],
          tooltip: {
            fixed: {
              enabled: false
            },
            x: {
              show: true
            },
            y: {
              show: true
            },
            marker: {
              show: false
            }
          }
        }
      },
      reasonAccountGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'area',
            sparkline: {
              enabled: false
            }
          },
          title: {
            text: "Reason Account",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight',
            width: 2,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              show: true,
              axisTicks: {
                show: false,
              },
              axisBorder: {
                show: true,
              },
              labels: {
                show: false,
                style: {
                  colors: '#556ee6',
                }
              },
            }
          ],
          tooltip: {
            fixed: {
              enabled: false
            },
            x: {
              show: true
            },
            y: {
              show: true
            },
            marker: {
              show: false
            }
          }
        }
      },
      reasonIceBreakerSendGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'area',
            sparkline: {
              enabled: false
            }
          },
          title: {
            text: "Reason IB Send",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight',
            width: 2,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              show: true,
              axisTicks: {
                show: false,
              },
              axisBorder: {
                show: true,
              },
              labels: {
                show: false,
                style: {
                  colors: '#556ee6',
                }
              },
            }
          ],
          tooltip: {
            fixed: {
              enabled: false
            },
            x: {
              show: true
            },
            y: {
              show: true
            },
            marker: {
              show: false
            }
          }
        }
      },
      reasonIceBreakerAcceptGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'area',
            sparkline: {
              enabled: false
            }
          },
          title: {
            text: "Reason IB Accept",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight',
            width: 2,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              show: true,
              axisTicks: {
                show: false,
              },
              axisBorder: {
                show: true,
              },
              labels: {
                show: false,
                style: {
                  colors: '#556ee6',
                }
              },
            }
          ],
          tooltip: {
            fixed: {
              enabled: false
            },
            x: {
              show: true
            },
            y: {
              show: true
            },
            marker: {
              show: false
            }
          }
        }
      },
      reasonSendLikeGraph: {
        series: [],
        chartOptions: {
          chart: {
            type: 'area',
            sparkline: {
              enabled: false
            }
          },
          title: {
            text: "Reason Send Likes",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              color:  '#222222'
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight',
            width: 2,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [
            {
              show: true,
              axisTicks: {
                show: false,
              },
              axisBorder: {
                show: true,
              },
              labels: {
                show: false,
                style: {
                  colors: '#556ee6',
                }
              },
            }
          ],
          tooltip: {
            fixed: {
              enabled: false
            },
            x: {
              show: true
            },
            y: {
              show: true
            },
            marker: {
              show: false
            }
          }
        }
      },

      ageLeadsGraph: {
        series:[],
        chartOptions: {
          chart: {
            id: 'performance-leads-age',
            type: 'pie',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-age-leads-distri'
                },
                svg: {
                  filename: 'performance-age-leads-distri'
                }
              }
            }
          },
          dataLabels: {
            enabled: true
          },
          title: {
            text: "Leads Age Distribution",
            align: 'left',
            offsetX: 0,
            offsetY: 0,
            margin: 10,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              color:  '#263238'
            },
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          colors: ["#A300D6", "#7D02EB", "#5653FE", "#2983FF", "#4ECDC4", "#4CAF50", "#90EE7E", "#F9CE1D", "#FF9800", "#D4526E"],
          legend: {
            position: 'left'
          },
        }
      },
      agePaidGraph: {
        series:[],
        chartOptions: {
          chart: {
            id: 'performance-paid-age',
            type: 'pie',
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              },
              export: {
                png: {
                  filename: 'performance-age-paid-distri'
                },
                svg: {
                  filename: 'performance-age-paid-distri'
                }
              }
            }
          },
          title: {
            text: "Payments Age Distribution",
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              color:  '#263238'
            },
          },
          dataLabels: {
            enabled: true
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          colors: ["#A300D6", "#7D02EB", "#5653FE", "#2983FF", "#4ECDC4", "#4CAF50", "#90EE7E", "#F9CE1D", "#FF9800", "#D4526E"],
          legend: {
            position: 'left'
          },
        }
      },

      filtersOffers: {
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'week',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        paymentMethod: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.method_all")},
            {value: 'C', text: this.$t("finance.method_card")},
            {value: 'S', text: this.$t("finance.method_store")},
          ]
        },
        paymentProcessor: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.processor_all")},
            {value: 'payplug', text: this.$t("finance.processor_payplug")},
            {value: 'stripe', text: this.$t("finance.processor_stripe")},
            {value: 'hipay', text: this.$t("finance.processor_hipay")},
            {value: '', text: '--------------'},
            {value: 'GP', text: this.$t("finance.processor_google")},
            {value: 'AP', text: this.$t("finance.processor_apple")},
          ]
        },
      },

      filtersPerformance: {
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'week',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        promo: {
          selected: 'all',
          options: [
            {value: 'all', text: "All products"},
            {value: 1, text: "Only Promo"},
            {value: 0, text: "No Promo"}
          ]
        },
        paymentMethod: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.method_all")},
            {value: 'C', text: this.$t("finance.method_card")},
            {value: 'S', text: this.$t("finance.method_store")},
          ]
        },
        paymentProcessor: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.processor_all")},
            {value: 'payplug', text: this.$t("finance.processor_payplug")},
            {value: 'stripe', text: this.$t("finance.processor_stripe")},
            {value: 'hipay', text: this.$t("finance.processor_hipay")},
            {value: '', text: '--------------'},
            {value: 'GP', text: this.$t("finance.processor_google")},
            {value: 'AP', text: this.$t("finance.processor_apple")},
          ]
        },
        subscriptions: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.subscriptions_all")},
            {value: 'sub_1_week', text: this.$t("finance.sub_1_week")},
            {value: 'sub_1_month', text: this.$t("finance.sub_1_month")},
            {value: 'sub_3_month', text: this.$t("finance.sub_3_month")},
            {value: 'sub_6_month', text: this.$t("finance.sub_6_month")},
            {value: '', text: '---------'},
            {value: 'sub_12_month', text: this.$t("finance.sub_12_month")},
            {value: 'sub_lifetime', text: this.$t("finance.sub_lifetime")},
            {value: 'sub_1_month_ft3d', text: this.$t("finance.sub_1_month_ft3d")},
          ]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
      },

      filtersPerformancePacks: {
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'week',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        promo: {
          selected: 'all',
          options: [
            {value: 'all', text: "All products"},
            {value: 1, text: "Only Promo"},
            {value: 0, text: "No Promo"}
          ]
        },
        paymentMethod: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.method_all")},
            {value: 'C', text: this.$t("finance.method_card")},
            {value: 'S', text: this.$t("finance.method_store")},
          ]
        },
        paymentProcessor: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.processor_all")},
            {value: 'payplug', text: this.$t("finance.processor_payplug")},
            {value: 'stripe', text: this.$t("finance.processor_stripe")},
            {value: 'hipay', text: this.$t("finance.processor_hipay")},
            {value: '', text: '--------------'},
            {value: 'GP', text: this.$t("finance.processor_google")},
            {value: 'AP', text: this.$t("finance.processor_apple")},
          ]
        },
        packs: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.packs_all")},
            {value: '', text: '---------'},
            {value: 'icebreakers', text: this.$t("finance.packs_icebreakers")},
            {value: 'icebreaker_12', text: this.$t("finance.icebreaker_12")},
            {value: 'icebreaker_35', text: this.$t("finance.icebreaker_35")},
            {value: 'icebreaker_65', text: this.$t("finance.icebreaker_65")},
            {value: '', text: '---------'},
            {value: 'boosts', text: this.$t("finance.packs_boosts")},
            {value: 'boost_5', text: this.$t("finance.boost_5")},
            {value: 'boost_10', text: this.$t("finance.boost_10")},
            {value: 'boost_20', text: this.$t("finance.boost_20")},
          ]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
      },

      filtersPerformanceLeads: {
        fromDate: null,
        toDate: null,
        limitDate: null,
        dates: {
          dateRange: null,
          selected: 'week',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        subscriptions: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.subscriptions_all")},
            {value: 'sub_1_week', text: this.$t("finance.sub_1_week")},
            {value: 'sub_1_month', text: this.$t("finance.sub_1_month")},
            {value: 'sub_3_month', text: this.$t("finance.sub_3_month")},
            {value: 'sub_6_month', text: this.$t("finance.sub_6_month")},
            {value: '', text: '---------'},
            {value: 'sub_12_month', text: this.$t("finance.sub_12_month")},
            {value: 'sub_lifetime', text: this.$t("finance.sub_lifetime")},
            {value: 'sub_1_month_ft3d', text: this.$t("finance.sub_1_month_ft3d")},
          ]
        },
        packs: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.packs_all")},
            {value: 'no', text: this.$t("finance.packs_no")},
            {value: '', text: '---------'},
            {value: 'icebreakers', text: this.$t("finance.packs_icebreakers")},
            {value: 'icebreaker_12', text: this.$t("finance.icebreaker_12")},
            {value: 'icebreaker_35', text: this.$t("finance.icebreaker_35")},
            {value: 'icebreaker_65', text: this.$t("finance.icebreaker_65")},
            {value: '', text: '---------'},
            {value: 'boosts', text: this.$t("finance.packs_boosts")},
            {value: 'boost_5', text: this.$t("finance.boost_5")},
            {value: 'boost_10', text: this.$t("finance.boost_10")},
            {value: 'boost_20', text: this.$t("finance.boost_20")},
            {value: '', text: '----- OLD -----'},
            {value: 'icebreaker_3', text: this.$t("finance.icebreaker_3")},
            {value: 'icebreaker_5', text: this.$t("finance.icebreaker_5")},
            {value: 'icebreaker_10', text: this.$t("finance.icebreaker_10")},
            {value: 'icebreaker_15', text: this.$t("finance.icebreaker_15")},
            {value: 'icebreaker_30', text: this.$t("finance.icebreaker_30")},
            {value: '', text: '---------'},
            {value: 'credits', text: this.$t("finance.packs_credits")},
            {value: 'pack_mini', text: this.$t("finance.pack_mini")},
            {value: 'pack_basic', text: this.$t("finance.pack_basic")},
            {value: 'pack_medium', text: this.$t("finance.pack_medium")},
            {value: 'pack_mega', text: this.$t("finance.pack_mega")},
            {value: 'pack_giga', text: this.$t("finance.pack_giga")},
            {value: 'pack_ultimate', text: this.$t("finance.icebreaker_30")},
          ]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
        genders: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.all_genders")},
            {value: 1, text: this.$t("users.search.genderMale")},
            {value: 2, text: this.$t("users.search.genderFemale")}
          ]
        },
        minAge: null,
        maxAge: null
      },

      filtersProjection: {
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'today',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'tomorrow', text:this.$t("dates.tomorrow")},
            {value:'week', text:this.$t("dates.nextWeek")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        paymentMethod: {
          selected: '',
          options: [
            {value: '', text: this.$t("finance.method_all")},
            {value: 'C', text: this.$t("finance.method_card")},
            {value: 'S', text: this.$t("finance.method_store")},
          ]
        },
        paymentProcessor: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.processor_all")},
            {value: 'payplug', text: this.$t("finance.processor_payplug")},
            {value: 'stripe', text: this.$t("finance.processor_stripe")},
            {value: 'hipay', text: this.$t("finance.processor_hipay")},
            {value: '', text: '--------------'},
            {value: 'GP', text: this.$t("finance.processor_google")},
            {value: 'AP', text: this.$t("finance.processor_apple")},
          ]
        },
        subscriptions: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.subscriptions_all")},
            {value: 'sub_1_week', text: this.$t("finance.sub_1_week")},
            {value: 'sub_1_month', text: this.$t("finance.sub_1_month")},
            {value: 'sub_3_month', text: this.$t("finance.sub_3_month")},
            {value: 'sub_6_month', text: this.$t("finance.sub_6_month")},
            {value: '', text: '---------'},
            {value: 'sub_12_month', text: this.$t("finance.sub_12_month")},
            {value: 'sub_lifetime', text: this.$t("finance.sub_lifetime")},
            {value: 'sub_1_month_ft3d', text: this.$t("finance.sub_1_month_ft3d")},
          ]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
        status: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.status_all")},
            {value: 'A', text: this.$t("finance.status_sub_A")},
            {value: 'S', text: this.$t("finance.status_sub_S")},
          ]
        }
      },
      /* User profile */
      isUserPaneDisplayed: false,
      userTabs:[],
      userTabsActive: '',
      userMedia: {
        media: [],
        index: -1
      },
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">
      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <!-- Performance Leads -->
      <div class="card mb-3">
        <div class="card-body">
          <h3 class="mb-4">{{ $t("finance.leads_performance_title") }}</h3>

          <!-- Filters -->
          <b-form inline class="row gy-2 gx-3 align-items-center" id="performanceLeadsFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="performanceLeadsDatesFilter"
                  @change="handleDatePerformanceLeadsChange"
                  v-model="filtersPerformanceLeads.dates.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformanceLeads.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filtersPerformanceLeads.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filtersPerformanceLeads.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- limit date -->
            <div class="col-sm-auto d-flex">
              <date-picker
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_limit_pay_date')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filtersPerformanceLeads.limitDate"
                  class="me-lg-2"
                  append-to-body ></date-picker>
            </div>

            <!-- Countries -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceLeadsCountriesFilter"
                  v-model="filtersPerformanceLeads.countries.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformanceLeads.countries.options">
              </b-form-select>
            </div>

            <!-- Genders -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceLeadsGenderFilter"
                  v-model="filtersPerformanceLeads.genders.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformanceLeads.genders.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Ages -->
            <div class="col-sm-auto">
              <b-form-input
                  v-model="filtersPerformanceLeads.minAge"
                  placeholder="Age min"
                  style="width:80px;"
              >
              </b-form-input>
            </div>
            <div class="col-sm-auto">
              <b-form-input
                  v-model="filtersPerformanceLeads.maxAge"
                  placeholder="Age max"
                  class="me-lg-1"
                  style="width:90px;"
              >
              </b-form-input>
            </div>

            <!-- Subscriptions -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceLeadsSubFilter"
                  v-model="filtersPerformanceLeads.subscriptions.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformanceLeads.subscriptions.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Packs -->
            <div class="col-sm-auto">
              <b-form-select
                  id="transactionsPackFilter"
                  v-model="filtersPerformanceLeads.packs.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformanceLeads.packs.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Organic -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceLeadsOrganicFilter"
                  v-model="filtersPerformanceLeads.organic.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformanceLeads.organic.options">
              </b-form-select>
            </div>

            <!-- Ads -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceLeadsAdsFilter"
                  v-model="filtersPerformanceLeads.ads.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformanceLeads.ads.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filtersPerformanceLeads.ads.selected !== 'all'">
              <b-form-select
                  id="performanceLeadsAdsData1Filter"
                  v-model="filtersPerformanceLeads.adsData1.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformanceLeads.adsData1.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filtersPerformanceLeads.adsData1.selected !== 'all'">
              <b-form-select
                  id="performanceLeadsAdsData2Filter"
                  v-model="filtersPerformanceLeads.adsData2.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformanceLeads.adsData2.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filtersPerformanceLeads.adsData2.selected !== 'all'">
              <b-form-select
                  id="performanceLeadsAdsData3Filter"
                  v-model="filtersPerformanceLeads.adsData3.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformanceLeads.adsData3.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processPerformanceLeadsFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
          <hr/>

          <!-- Loader -->
          <div class="row d-flex justify-content-center">
            <vue-ellipse-progress
                v-show="isLoadingPerformanceLeads"
                :loading="isLoadingPerformanceLeads"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#f8f8fb"
                :size="100"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                class="mt-5 mb-5"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>

          <div class="row">

            <!-- Plain Data -->
            <div class="col-12 col-lg-3">
              <div class="card bg-success mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-white fw-medium mb-2">Amount Earned</p>
                      <h4 class="mb-0 text-white">
                        {{ stats.totalAmountEarned }} € <small class="text-white-50 d-inline-block ms-2"> {{ stats.total_amount_avg }} € / user</small>
                      </h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-white text-success">
                        <i class="bx bx-stats font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-3">
              <div class="card mini-stats-wid">
                <div class="card-body mt-0">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">{{ $t("finance.leads") }}</p>
                      <h4 class="mb-0"><small>{{ stats.leads }} <span class="text-success">{{ stats.leads_perf }} %</span></small></h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-info text-light">
                        <i class="bx bx-check-circle font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-2">
              <div class="card mini-stats-wid">
                <div class="card-body mt-0">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">{{ $t("finance.leads_paid") }}</p>
                      <h4 class="mb-0"><small>{{ stats.paid }}</small></h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-warning">
                        <i class="bx bx-dollar font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-2">
              <div class="card mini-stats-wid">
                <div class="card-body mt-0">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">{{ $t("finance.leads_orders") }}</p>
                      <h4 class="mb-0"><small>{{ stats.orders }}</small></h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-success">
                        <i class="bx bx-dollar font-size-24"></i>
                      </span>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="col-12 col-lg-2">
              <div class="card mini-stats-wid">
                <div class="card-body mt-0">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">{{ $t("finance.remainingSubs") }}</p>
                      <h4 class="mb-0"><small>{{ stats.remainingSubs }}</small></h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                        <span class="avatar-title bg-danger text-light">
                          <i class="bx bx-check-circle font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- Charts -->
          <div class="row">
            <div class="col-12 col-lg-6">
              <apexchart
                  ref="performanceLeadsHistoryChart"
                  class="apex-charts"
                  type="line"
                  dir="ltr"
                  height="250"
                  :series="performanceLeadsGraph.series"
                  :options="performanceLeadsGraph.chartOptions"
              ></apexchart>
            </div>
            <div class="col-12 col-lg-6">
                <apexchart
                    ref="performanceLeadsAmountHistoryChart"
                    class="apex-charts"
                    type="line"
                    dir="ltr"
                    height="250"
                    :series="performanceLeadsAmountGraph.series"
                    :options="performanceLeadsAmountGraph.chartOptions"
                ></apexchart>

            </div>
            <div class="col-12 mt-2">
              <apexchart
                  ref="performanceLeadsCumulativeHistoryAmountChart"
                  class="apex-charts"
                  type="area"
                  dir="ltr"
                  height="250"
                  :series="performanceLeadsCumulativeAmountGraph.series"
                  :options="performanceLeadsCumulativeAmountGraph.chartOptions"
              ></apexchart>

              <apexchart
                  ref="performanceLeadsCumulativeHistoryPaymentsChart"
                  class="apex-charts"
                  type="bar"
                  dir="ltr"
                  height="350"
                  :series="performanceLeadsCumulativePaymentsGraph.series"
                  :options="performanceLeadsCumulativePaymentsGraph.chartOptions"
              ></apexchart>
            </div>

          </div>

          <div class="row mt-5">

            <!-- Amount -->
            <div class="col-12">
              <div class="table-responsive">
                <table
                    class="table project-list-table table-nowrap table-centered align-middle"
                >
                  <thead class="table-light">
                  <tr>
                    <th scope="col">Currency</th>
                    <th scope="col">Total</th>
                    <th scope="col">First</th>
                    <th scope="col">Renews</th>
                    <th scope="col">First Subs</th>
                    <th scope="col">First Packs</th>
                    <th scope="col">First Others</th>
                    <th scope="col">Renew 1</th>
                    <th scope="col">Renew 2</th>
                    <th scope="col">Renew 3</th>
                    <th scope="col">Renew 4</th>
                    <th scope="col">Renew 5</th>
                    <th scope="col">Renew 6</th>
                    <th scope="col">Renew +</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="currency in stats.lead_currencies" :key="currency.currency">
                    <td><span class="text-dark fw-medium mb-2">{{ currency.currency }}</span></td>
                    <td class="bg-dark text-white">{{ currency.amountTotalHT / 100}} HT<span class="text-white-50 float-end"><small>{{ currency.amountTotal / 100}}</small></span></td>
                    <td class="bg-success text-white">{{ currency.firstAmountHT / 100}} HT<span class="text-white-50 float-end"><small>{{ currency.firstAmount / 100}}</small></span></td>
                    <td class="bg-info text-white">{{ currency.renewsAmountHT / 100}} HT<span class="text-white-50 float-end"><small>{{ currency.renewsAmount / 100}}</small></span></td>
                    <td class="text-success">{{ currency.firstSubscriptionsHT / 100}} HT<span class="text-white-50 float-end"><small>{{ currency.firstSubscriptions / 100}}</small></span></td>
                    <td class="text-success">{{ currency.firstPacksHT / 100}} HT<span class="float-end"><small>{{ currency.firstPacks / 100}}</small></span></td>
                    <td class="text-success">{{ currency.firstOthersHT / 100}} HT<span class="float-end"><small>{{ currency.firstOthers / 100}}</small></span></td>
                    <td class="text-muted">{{ currency.renew_1_amountHT / 100}} HT<span class="float-end"><small>{{ currency.renew_1_amount / 100}}</small></span></td>
                    <td class="text-muted">{{ currency.renew_2_amountHT / 100}} HT<span class="float-end"><small>{{ currency.renew_2_amount / 100}}</small></span></td>
                    <td class="text-muted">{{ currency.renew_3_amountHT / 100}} HT<span class="float-end"><small>{{ currency.renew_3_amount / 100}}</small></span></td>
                    <td class="text-muted">{{ currency.renew_4_amountHT / 100}} HT<span class="float-end"><small>{{ currency.renew_4_amount / 100}}</small></span></td>
                    <td class="text-muted">{{ currency.renew_5_amountHT / 100}} HT<span class="float-end"><small>{{ currency.renew_5_amount / 100}}</small></span></td>
                    <td class="text-muted">{{ currency.renew_6_amountHT / 100}} HT<span class="float-end"><small>{{ currency.renew_6_amount / 100}}</small></span></td>
                    <td class="text-muted">{{ currency.renew_more_amountHT / 100}} HT<span class="float-end"><small>{{ currency.renew_more_amount / 100}}</small></span></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-12 bg-light card">
              <div class="card-title mt-2">Age Stats</div>
              <div class="card-title-desc">Performance by Age interval</div>
            </div>
          </div>

          <div class="row">

            <div class="col-12 col-lg-6">
              <apexchart
                  ref="performanceAgeChart"
                  class="apex-charts"
                  type="line"
                  dir="ltr"
                  height="350"
                  :series="performanceAgeGraph.series"
                  :options="performanceAgeGraph.chartOptions"
              ></apexchart>

              <!--<div class="table-responsive">
                <table
                    class="table project-list-table table-nowrap table-centered align-middle"
                >
                  <thead class="table-light">
                  <tr>
                    <th scope="col">Age Interval</th>
                    <th scope="col">Leads</th>
                    <th scope="col">Paid</th>
                    <th scope="col">Amount HT</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="age in stats.ageData" :key="age.interval">
                      <td class="text-dark"><strong>{{ age.interval }}</strong></td>
                      <td class="text-muted">{{ age.leads }}</td>
                      <td class="text-dark">{{ age.paid }} <span class="float-end d-inline-block bg-success p-2 text-white fw-medium">{{ age.perf_paid }} %</span> </td>
                      <td class="text-muted">{{ age.amount }}</td>
                    </tr>
                  </tbody>
                </table>
              </div> -->
            </div>

            <div class="col-12 col-lg-3">
              <!-- graph AgeLeads -->
              <apexchart
                  ref="performanceLeadsAgeChart"
                  height="350"
                  type="pie"
                  dir="ltr"
                  :series="ageLeadsGraph.series"
                  :options="ageLeadsGraph.chartOptions"
              ></apexchart>
            </div>

            <div class="col-12 col-lg-3">
              <!-- graph AgePaids -->
              <apexchart
                  ref="performancePaidAgeChart"
                  height="350"
                  type="pie"
                  dir="ltr"
                  :series="agePaidGraph.series"
                  :options="agePaidGraph.chartOptions"
              ></apexchart>
            </div>

          </div>

          <div class="row mt-5">
            <div class="col-12 bg-light card">
              <div class="card-title mt-2">Reasons Stats</div>
              <div class="card-title-desc">Actions who leads to payments.</div>
            </div>

            <div class="col-12">
              <apexchart
                  ref="performanceReasonAllHistoryChart"
                  class="apex-charts"
                  type="bar"
                  dir="ltr"
                  height="250"
                  :series="reasonAllGraph.series"
                  :options="reasonAllGraph.chartOptions"
              ></apexchart>
            </div>

            <div class="col-lg-4 col-6">
              <apexchart
                  ref="performanceReasonLikeChart"
                  class="apex-charts"
                  type="area"
                  dir="ltr"
                  height="150"
                  :series="reasonUnlockLikeGraph.series"
                  :options="reasonUnlockLikeGraph.chartOptions"
              ></apexchart>
            </div>

            <div class="col-lg-4 col-6">
              <apexchart
                  ref="performanceReasonVideoLikeChart"
                  class="apex-charts"
                  type="area"
                  dir="ltr"
                  height="150"
                  :series="reasonUnlockVideoLikeGraph.series"
                  :options="reasonUnlockVideoLikeGraph.chartOptions"
              ></apexchart>
            </div>

            <div class="col-lg-4 col-6">
                <apexchart
                    ref="performanceReasonAccountChart"
                    class="apex-charts"
                    type="area"
                    dir="ltr"
                    height="150"
                    :series="reasonAccountGraph.series"
                    :options="reasonAccountGraph.chartOptions"
                ></apexchart>
              </div>
          </div>

          <div class="row mt-5">
            <div class="col-lg-4 col-6">
              <apexchart
                  ref="performanceReasonIBAcceptChart"
                  class="apex-charts"
                  type="area"
                  dir="ltr"
                  height="150"
                  :series="reasonIceBreakerAcceptGraph.series"
                  :options="reasonIceBreakerAcceptGraph.chartOptions"
              ></apexchart>
            </div>

            <div class="col-lg-4 col-6">
              <apexchart
                  ref="performanceReasonIBSendChart"
                  class="apex-charts"
                  type="area"
                  dir="ltr"
                  height="150"
                  :series="reasonIceBreakerSendGraph.series"
                  :options="reasonIceBreakerSendGraph.chartOptions"
              ></apexchart>
            </div>

            <div class="col-lg-4 col-6">
              <apexchart
                  ref="performanceReasonSendLikeChart"
                  class="apex-charts"
                  type="area"
                  dir="ltr"
                  height="150"
                  :series="reasonSendLikeGraph.series"
                  :options="reasonSendLikeGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>
      </div>

      <!-- Offers -->
      <div class="card mb-3">
        <div class="card-body">
          <h3 class="mb-4">Promos Stats</h3>

          <!-- Filters -->
          <b-form inline class="row gy-2 gx-3 align-items-center" id="performanceFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="offersDatesFilter"
                  @change="handleDateOffersChange"
                  v-model="filtersOffers.dates.selected"
                  class="form-select me-lg-1"
                  :options="filtersOffers.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filtersOffers.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filtersOffers.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- Countries -->
            <div class="col-sm-auto">
              <b-form-select
                  id="offersCountriesFilter"
                  v-model="filtersOffers.countries.selected"
                  class="form-select me-lg-1"
                  :options="filtersOffers.countries.options">
              </b-form-select>
            </div>

            <!-- PaymentMethod -->
            <div class="col-sm-auto">
              <b-form-select
                  id="offersMethodFilter"
                  v-model="filtersOffers.paymentMethod.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersOffers.paymentMethod.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentProcessor -->
            <div class="col-sm-auto">
              <b-form-select
                  id="offersProcessorFilter"
                  v-model="filtersOffers.paymentProcessor.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersOffers.paymentProcessor.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processOffersFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
          <hr/>

          <!-- Loader -->
          <div class="row d-flex justify-content-center">
            <vue-ellipse-progress
                v-show="isLoadingOffers"
                :loading="isLoadingOffers"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#f8f8fb"
                :size="100"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                class="mt-5 mb-5"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>

          <div v-if="!isLoadingOffers && statsOffers.length === 0" class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Empty Result</h4>
                  <p>No Offers were found for these filters. Try again.</p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!isLoadingOffers && statsOffers.length > 0" class="row">
            <div v-for="offer in statsOffers" :key="offer.name" class="card">
              <div class="card-body">
                <h3 class="mb-4">{{ offer.nameFormated }}</h3>

                <div class="row">

                  <div class="col-12">
                    <div class="table-responsive">
                      <table
                          class="table project-list-table table-nowrap table-centered align-middle"
                      >
                        <thead class="table-light">
                        <tr>
                          <th scope="col">Count</th>
                          <th scope="col">Displayed</th>
                          <th scope="col">Avg Presented</th>
                          <th scope="col">Firsts</th>
                          <th scope="col">Renews</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td><span class="text-dark fw-medium">{{ offer.count }}</span></td>
                          <td><span class="text-dark">{{ offer.displayed }}</span></td>
                          <td><span class="text-dark">{{ offer.presentedCount }}</span></td>
                          <td class="">
                          <span class="d-inline-block bg-success text-white fw-medium p-2 me-2">
                          {{ offer.perf }}%
                          </span>
                            <span class="fw-bold text-success">{{ offer.firsts }}</span>
                          </td>
                          <td class="">
                          <!--<span class="d-inline-block bg-info text-white fw-medium p-2">
                          {{ offer.perf_renew }}%
                          </span>-->
                            <span class="text-info fw-bold">{{ offer.renews }}</span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="table-responsive">
                      <table
                          class="table project-list-table table-nowrap table-centered align-middle"
                      >
                        <thead class="table-light">
                        <tr>
                          <th scope="col">Currency</th>
                          <th scope="col">Total</th>
                          <th scope="col">First</th>
                          <th scope="col">First Amount</th>
                          <th scope="col">Renews</th>
                          <th scope="col">Renews Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="currency in offer.currencies" :key="currency.currency">
                          <td><span class="text-dark fw-medium mb-2">{{ currency.currency }}</span></td>
                          <td class="text-dark"><span class="d-inline-block p-2 me-2 bg-dark text-white fw-bold">{{ currency.amountTotalHT / 100}} HT</span><small>{{ currency.amountTotal / 100}} TTC</small></td>
                          <td class="text-success">{{ currency.first}}</td>
                          <td class="text-dark"><span class="d-inline-block p-2 me-2 bg-success text-white fw-bold">{{ currency.firstAmountHT / 100}} HT</span><small>{{ currency.firstAmount / 100}} TTC </small></td>
                          <td class="text-info">{{ currency.renews}}</td>
                          <td class="text-dark"><span class="d-inline-block p-2 me-2 bg-info text-white fw-bold">{{ currency.renewsAmountHT / 100}} HT</span><small>{{ currency.renewsAmount / 100}} TTC</small></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Performance Subsriptions Renews -->
      <div class="card mb-3">
        <div class="card-body">
          <h3 class="mb-4">{{ $t("finance.renews_performance_title") }}</h3>

          <!-- Filters -->
          <b-form inline class="row gy-2 gx-3 align-items-center" id="performanceFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="performanceDatesFilter"
                  @change="handleDatePerformanceChange"
                  v-model="filtersPerformance.dates.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filtersPerformance.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filtersPerformance.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- Countries -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceCountriesFilter"
                  v-model="filtersPerformance.countries.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.countries.options">
              </b-form-select>
            </div>

            <!-- Subscriptions -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceSubFilter"
                  v-model="filtersPerformance.subscriptions.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformance.subscriptions.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Promo -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performancePromoFilter"
                  v-model="filtersPerformance.promo.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformance.promo.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentMethod -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceMethodFilter"
                  v-model="filtersPerformance.paymentMethod.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformance.paymentMethod.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentProcessor -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceProcessorFilter"
                  v-model="filtersPerformance.paymentProcessor.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformance.paymentProcessor.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Organic -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceOrganicFilter"
                  v-model="filtersPerformance.organic.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.organic.options">
              </b-form-select>
            </div>

            <!-- Ads -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceAdsFilter"
                  v-model="filtersPerformance.ads.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.ads.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filtersPerformance.ads.selected !== 'all'">
              <b-form-select
                  id="performanceAdsData1Filter"
                  v-model="filtersPerformance.adsData1.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.adsData1.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filtersPerformance.adsData1.selected !== 'all'">
              <b-form-select
                  id="performanceAdsData2Filter"
                  v-model="filtersPerformance.adsData2.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.adsData2.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filtersPerformance.adsData2.selected !== 'all'">
              <b-form-select
                  id="performanceAdsData3Filter"
                  v-model="filtersPerformance.adsData3.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformance.adsData3.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processPerformanceFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
          <hr/>

          <!-- Loader -->
          <div class="row d-flex justify-content-center">
            <vue-ellipse-progress
                v-show="isLoadingPerformance"
                :loading="isLoadingPerformance"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#f8f8fb"
                :size="100"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                class="mt-5 mb-5"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>

          <div class="row">

            <!-- Plain Data -->
            <div class="col-12 col-lg-3">

              <div class="card bg-success mini-stats-wid">
                <div class="card-body">
                  <div class="media mt-3">
                    <div class="media-body">
                      <p class="text-white fw-medium mb-2">{{ $t("finance.performance") }}</p>
                      <h4 class="mb-0 text-white">{{ stats.renews_perf }} %</h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-white text-success">
                        <i class="bx bx-stats font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-12 col-lg-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">{{ $t("finance.renews_success") }}</p>
                      <h4 class="mb-0"><small>{{ stats.renews_success }}</small></h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-info text-light">
                        <i class="bx bx-check-circle font-size-24"></i>
                      </span>
                    </div>
                  </div>

                  <div class="media mt-3">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">{{ $t("finance.renews_failed") }}</p>
                      <h4 class="mb-0"><small>{{ stats.renews_failed }}</small></h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-danger">
                        <i class="bx bx-error font-size-24"></i>
                      </span>
                    </div>
                  </div>

                </div>
              </div>

            </div>

            <div class="col-12 col-lg-6">
              <apexchart
                  ref="performanceProcessorsChart"
                  class="apex-charts"
                  type="bar"
                  dir="ltr"
                  height="200"
                  :series="performanceProcessorGraph.series"
                  :options="performanceProcessorGraph.chartOptions"
              ></apexchart>
            </div>

          </div>
          <div class="row">

            <!-- Charts -->
            <div class="col-12">
              <apexchart
                  ref="performanceHistoryRatioChart"
                  class="apex-charts"
                  type="area"
                  dir="ltr"
                  height="150"
                  :series="performanceRatioGraph.series"
                  :options="performanceRatioGraph.chartOptions"
              ></apexchart>

              <apexchart
                  ref="performanceHistoryChart"
                  class="apex-charts"
                  type="bar"
                  dir="ltr"
                  height="200"
                  :series="performanceGraph.series"
                  :options="performanceGraph.chartOptions"
              ></apexchart>

            </div>

          </div>
        </div>
      </div>

      <!-- Performance Packs Renews -->
      <div class="card mb-3">
        <div class="card-body">
          <h3 class="mb-4">{{ $t("finance.renews_packs_performance_title") }}</h3>

          <!-- Filters -->
          <b-form inline class="row gy-2 gx-3 align-items-center" id="performancePacksFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="performancePacksDatesFilter"
                  @change="handleDatePerformancePacksChange"
                  v-model="filtersPerformancePacks.dates.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformancePacks.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filtersPerformancePacks.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filtersPerformancePacks.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- Countries -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performancePacksCountriesFilter"
                  v-model="filtersPerformancePacks.countries.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformancePacks.countries.options">
              </b-form-select>
            </div>

            <!-- Packs -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performancePacksPackFilter"
                  v-model="filtersPerformancePacks.packs.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformancePacks.packs.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Promo -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performancePacksPromoFilter"
                  v-model="filtersPerformancePacks.promo.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformancePacks.promo.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentMethod -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performancePacksMethodFilter"
                  v-model="filtersPerformancePacks.paymentMethod.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformancePacks.paymentMethod.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentProcessor -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performancePacksProcessorFilter"
                  v-model="filtersPerformancePacks.paymentProcessor.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersPerformancePacks.paymentProcessor.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Organic -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performancePacksOrganicFilter"
                  v-model="filtersPerformancePacks.organic.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformancePacks.organic.options">
              </b-form-select>
            </div>

            <!-- Ads -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performancePacksAdsFilter"
                  v-model="filtersPerformancePacks.ads.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformancePacks.ads.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filtersPerformancePacks.ads.selected !== 'all'">
              <b-form-select
                  id="performancePacksAdsData1Filter"
                  v-model="filtersPerformancePacks.adsData1.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformancePacks.adsData1.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filtersPerformancePacks.adsData1.selected !== 'all'">
              <b-form-select
                  id="performancePacksAdsData2Filter"
                  v-model="filtersPerformancePacks.adsData2.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformancePacks.adsData2.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filtersPerformancePacks.adsData2.selected !== 'all'">
              <b-form-select
                  id="performancePacksAdsData3Filter"
                  v-model="filtersPerformancePacks.adsData3.selected"
                  class="form-select me-lg-1"
                  :options="filtersPerformancePacks.adsData3.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processPerformancePacksFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
          <hr/>

          <!-- Loader -->
          <div class="row d-flex justify-content-center">
            <vue-ellipse-progress
                v-show="isLoadingPerformancePacks"
                :loading="isLoadingPerformancePacks"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#f8f8fb"
                :size="100"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                class="mt-5 mb-5"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>

          <div class="row">

            <!-- Plain Data -->
            <div class="col-12 col-lg-3">

              <div class="card bg-success mini-stats-wid">
                <div class="card-body">
                  <div class="media mt-3">
                    <div class="media-body">
                      <p class="text-white fw-medium mb-2">{{ $t("finance.performance") }}</p>
                      <h4 class="mb-0 text-white">{{ stats.renews_packs_perf }} %</h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-white text-success">
                        <i class="bx bx-stats font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-12 col-lg-3">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">{{ $t("finance.renews_success") }}</p>
                      <h4 class="mb-0"><small>{{ stats.renews_packs_success }}</small></h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-info text-light">
                        <i class="bx bx-check-circle font-size-24"></i>
                      </span>
                    </div>
                  </div>

                  <div class="media mt-3">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">{{ $t("finance.renews_failed") }}</p>
                      <h4 class="mb-0"><small>{{ stats.renews_packs_failed }}</small></h4>
                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-danger">
                        <i class="bx bx-error font-size-24"></i>
                      </span>
                    </div>
                  </div>

                </div>
              </div>

            </div>

            <div class="col-12 col-lg-6">
              <apexchart
                  ref="performancePacksProcessorsChart"
                  class="apex-charts"
                  type="bar"
                  dir="ltr"
                  height="200"
                  :series="performancePacksProcessorGraph.series"
                  :options="performancePacksProcessorGraph.chartOptions"
              ></apexchart>
            </div>

          </div>
          <div class="row">

            <!-- Charts -->
            <div class="col-12">
              <apexchart
                  ref="performancePacksHistoryRatioChart"
                  class="apex-charts"
                  type="area"
                  dir="ltr"
                  height="150"
                  :series="performancePacksRatioGraph.series"
                  :options="performancePacksRatioGraph.chartOptions"
              ></apexchart>

              <apexchart
                  ref="performancePacksHistoryChart"
                  class="apex-charts"
                  type="bar"
                  dir="ltr"
                  height="200"
                  :series="performancePacksGraph.series"
                  :options="performancePacksGraph.chartOptions"
              ></apexchart>

            </div>

          </div>
        </div>
      </div>

      <!-- Projection Renews -->
      <div class="card">
        <div class="card-body">
          <h3 class="mb-4">{{ $t("finance.renews_projections_title") }}</h3>

          <!-- Filters -->
          <b-form inline class="row gy-2 gx-3 align-items-center" id="projectionsFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="projectionDatesFilter"
                  @change="handleDateProjectionsChange"
                  v-model="filtersProjection.dates.selected"
                  class="form-select me-lg-1"
                  :options="filtersProjection.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filtersProjection.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filtersProjection.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- Countries -->
            <div class="col-sm-auto">
              <b-form-select
                  id="projectionCountriesFilter"
                  v-model="filtersProjection.countries.selected"
                  class="form-select me-lg-1"
                  :options="filtersProjection.countries.options">
              </b-form-select>
            </div>

            <!-- Subscriptions -->
            <div class="col-sm-auto">
              <b-form-select
                  id="projectionsSubFilter"
                  v-model="filtersProjection.subscriptions.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersProjection.subscriptions.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentMethod -->
            <div class="col-sm-auto">
              <b-form-select
                  id="projectionsMethodFilter"
                  v-model="filtersProjection.paymentMethod.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersProjection.paymentMethod.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentProcessor -->
            <div class="col-sm-auto">
              <b-form-select
                  id="projectionsProcessorFilter"
                  v-model="filtersProjection.paymentProcessor.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filtersProjection.paymentProcessor.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Status -->
            <div class="col-sm-auto">
              <b-form-select
                  id="projectionsStatusFilter"
                  v-model="filtersProjection.status.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="st in filtersProjection.status.options" :key="st.value" :value="st.value">{{ st.text }}</option>
              </b-form-select>
            </div>

            <!-- Organic -->
            <div class="col-sm-auto">
              <b-form-select
                  id="performanceLeadsOrganicFilter"
                  v-model="filtersProjection.organic.selected"
                  class="form-select me-lg-1"
                  :options="filtersProjection.organic.options">
              </b-form-select>
            </div>

            <!-- Ads -->
            <div class="col-sm-auto">
              <b-form-select
                  id="projectionsAdsFilter"
                  v-model="filtersProjection.ads.selected"
                  class="form-select me-lg-1"
                  :options="filtersProjection.ads.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filtersProjection.ads.selected !== 'all'">
              <b-form-select
                  id="projectionsAdsData1Filter"
                  v-model="filtersProjection.adsData1.selected"
                  class="form-select me-lg-1"
                  :options="filtersProjection.adsData1.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filtersProjection.adsData1.selected !== 'all'">
              <b-form-select
                  id="projectionsAdsData2Filter"
                  v-model="filtersProjection.adsData2.selected"
                  class="form-select me-lg-1"
                  :options="filtersProjection.adsData2.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filtersProjection.adsData2.selected !== 'all'">
              <b-form-select
                  id="projectionsAdsData3Filter"
                  v-model="filtersProjection.adsData3.selected"
                  class="form-select me-lg-1"
                  :options="filtersProjection.adsData3.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processProjectionsFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
          <hr/>

          <!-- Loader -->
          <div class="row d-flex justify-content-center">
            <vue-ellipse-progress
                v-show="isLoadingProjection"
                :loading="isLoadingProjection"
                :angle="-90"
                color="#50a5f1"
                emptyColor="#999"
                emptyColorFill="#f8f8fb"
                :size="100"
                :thickness="3"
                :emptyThickness="2"
                lineMode="out 2"
                animation="bounce 700 400"
                fontColor="#666"
                :half="false"
                class="mt-5 mb-5"
                fontSize="1rem">
            </vue-ellipse-progress>
          </div>

          <!-- Stats -->
          <div class="row">

            <!-- Plain Data -->
            <div class="col-12 col-lg-4">

              <div class="row">

                <div class="col-12 col-lg-6">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("finance.status_sub_A") }}</p>
                          <h4 class="mb-0 text-primary">{{ stats.active }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-6">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("finance.status_sub_S") }}</p>
                          <h4 class="mb-0 text-danger">{{ stats.suspended }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="card">
                <div class="card-body">
                  <div class="media mt-3">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">{{ $t("finance.amount") }}</p>

                      <div v-for="currency in stats.currencies" :key="currency.currency">
                        <b>{{ currency.amount / 100}} {{ currency.currency }}</b> (<small>{{ currency.count }}</small>)
                      </div>

                    </div>
                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-info">
                        <i class="bx bxs-dollar-circle font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <!-- graph Products -->
            <div class="col-12 col-lg-4">
              <div class="card">
                <div class="card-body" id="cardChartProducts">
                  <h5 class="card-title">Products</h5>
                  <apexchart
                      ref="projectionsProductsChart"
                      height="200"
                      type="donut"
                      dir="ltr"
                      :series="productsGraph.series"
                      :options="productsGraph.chartOptions"
                  ></apexchart>
                </div>
              </div>
            </div>

            <!-- graph Processors -->
            <div class="col-12 col-lg-4">
              <div class="card">
                <div class="card-body" id="cardChartProcessors">
                  <h5 class="card-title">Processors</h5>
                  <apexchart
                      ref="projectionsProcessorsChart"
                      height="200"
                      type="donut"
                      dir="ltr"
                      :series="processorsGraph.series"
                      :options="processorsGraph.chartOptions"
                  ></apexchart>
                </div>
              </div>
            </div>

          </div>

          <!-- Top list tools -->
          <div class="row mb-3">
            <!-- Display settings -->
            <div class="col-lg-auto col-12">
              <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
                <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
              </b-select>

              {{ count }} {{ $t('resultsCount') }}
            </div>
            <!-- Pagination -->
            <div class="col-lg-auto col-12">
              <div class="m-1 pagination-rounded">
                <b-pagination
                    v-model="page"
                    :total-rows="count"
                    :per-page="pageSizes.selected"
                    first-number
                    last-number
                    @change="handlePageChange"
                    aria-controls="projections-list"
                ></b-pagination>
              </div>
            </div>
          </div>

          <!-- Result list -->
          <div class="row" v-if="!isLoadingProjection && projections.length > 0">
            <div class="table-responsive">
              <table
                  id="projections-list"
                  class="table project-list-table table-nowrap table-centered table-borderless align-middle"
              >
                <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t('finance.renewAt') }}</th>
                  <th scope="col">{{ $t('finance.status') }}</th>
                  <th scope="col">{{ $t('finance.orderid') }}</th>
                  <th scope="col">{{ $t('finance.amount') }}</th>
                  <th scope="col">{{ $t('finance.subscription') }}</th>
                  <th scope="col">{{ $t('finance.method') }}</th>
                  <th scope="col">{{ $t('finance.user') }}</th>
                  <th scope="col">{{ $t('action') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="projection in projections" :key="projection.id">
                  <td>
                    <p class="text-muted font-size-12">
                      <i class="bx bx-calendar-event"></i><span class="text-info">{{ formatDateString(projection.periodEndAt, 'DD MMM YYYY HH:mm') }}</span>
                    </p>
                  </td>
                  <td>
                <span
                    class="badge"
                    :class="{
                      'bg-success text-light': `${projection.status}` === 'A',
                      'bg-danger text-light': `${projection.status}` === 'S',
                    }"
                >{{ $t(`finance.status_sub_${projection.status}`) }}</span
                >
                  </td>
                  <td>
                    <p class="text-muted font-size-12"><strong>{{ projection.orderId }}</strong></p>
                  </td>
                  <td>
                    <p class="font-size-14" >
                  <span
                      class="text-dark fw-bold d-inline-block me-2 text-primary"
                  >{{ projection.amount/100 }} {{ projection.currency }}</span>
                    </p>
                  </td>
                  <td>
                    <p class="text-muted font-size-12">{{ $t(`finance.${projection.productId}`) }}</p>
                  </td>
                  <td>
                    <p class="text-muted font-size-12">
                      <img :src="getPaymentMethodImg(projection.paymentMethod, projection.paymentProcessor)" width="24" height="24" alt=""/>
                      {{ $t(`finance.processor_${projection.paymentProcessor}`) }}
                    </p>
                  </td>
                  <td>
                    <div class="media">
                      <div class="avatar-xs">
                        <img
                            :id="`projection-user-${projection.id}`"
                            :src="require('@/assets/images/users/default-user.png')"
                            class="d-flex rounded-circle avatar-xs" />
                      </div>
                      <div class="media-body ms-1">
                        <h5 class="font-size-14 mb-0">
                      <span
                          :class="{
                          'text-primary': projection.sex === 1,
                          'text-danger': projection.sex === 2,
                          'text-dark': projection.sex === 0,
                        }"
                      >
                        {{ projection.name || '-' }}
                      </span> {{ getAge(projection.birth) }}</h5>
                        <small class="text-muted">#{{ projection.userId }}</small>
                      </div>
                    </div>
                  </td>
                  <td>
                    <b-dropdown
                        class="card-drop"
                        variant="white"
                        menu-class="dropdown-menu-end"
                        right
                        toggle-class="p-0"
                    >
                      <template v-slot:button-content>
                        <i class="mdi mdi-dots-horizontal font-size-18"></i>
                      </template>
                      <b-dropdown-item
                          href="javascript: void(0);"
                          @click="showUser(projection.userId)"
                      >{{ $t("show_user") }}</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Result Empty -->
          <div class="row" v-if="!isLoadingProjection && projections.length === 0">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Empty Result</h4>
                  <p>No projected Subscriptions renews were found for these filters or search. Try again.</p>
                </div>
              </div>
            </div>
          </div>

          <!-- bottom list tools -->
          <div class="row mb-3">
            <!-- Display settings -->
            <div class="col-lg-auto col-12">
              <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
                <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
              </b-select>
            </div>
            <!-- Pagination -->
            <div class="col-lg-auto col-12">
              <div class="m-1 pagination-rounded">
                <b-pagination
                    v-model="page"
                    :total-rows="count"
                    :per-page="pageSizes.selected"
                    first-number
                    last-number
                    @change="handlePageChange"
                    aria-controls="projection-list"
                ></b-pagination>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
    <b-sidebar id="sidebar-right" right v-model="isUserPaneDisplayed">
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia">
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>

    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>
  </Layout>
</template>

<style>

.bg-canceled {
  background-color:#f1b44c !important;
}

.bg-ended {
  background-color: #efa2c5 !important;
}

.b-sidebar-right {
  width:35%;
}

.b-sidebar-body {
  padding:16px;
}

</style>
